.cluster-node {
    position: fixed;
    top: 0;
    left: 0;
    border-radius: 50%;
    // background: rgba(240, 240, 240, 0.4); // Fondo semitransparente para simular la membrana
    // border: 1px solid rgba(0, 0, 0, 0.1); // DEBUG para ver los bordes del cluster
    // box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.05);
    pointer-events: auto; // Debe poder ser arrastrado

    z-index: 5;

    // ajuste de centro (igual que las burbujas)
    transform-origin: center center;
}